/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class ItemCategoryTag extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let catName = null,
            textColor = '',
            hex = '',
            r = 0,
            g = 0,
            b = 0;

        if (this.props.category && this.props.category.color) {
            hex = this.props.category.color.replace("#", "");
            r = parseInt(hex.slice(0, 2), 16);
            g = parseInt(hex.slice(2, 4), 16);
            b = parseInt(hex.slice(4, 6), 16);
        }

        // stolen from stackoverflow...
        textColor = ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? '#000000' : '#FFFFFF';

        return (
            <div className="item-category-display" style={{'backgroundColor': this.props.category.color}}>
                <div className="item-category-name" style={{'color': textColor, 'backgroundColor': this.props.category.color}}>
                    {this.props.category.name}
                </div>
            </div>
        );
    }
}

ItemCategoryTag.propTypes = {
    category: PropTypes.object
};

ItemCategoryTag.defaultProps = {
    category: {}
};

export default ItemCategoryTag;
